// src/api/sanctuary/sanctuaryApi.ts

import baseApi from "../../lib/baseApi";
import type {
  SanctuaryRequestDTO,
  SanctuaryReviewDTO,
  SanctuaryOutcomeDTO,
  SanctuaryParticipationStatusDTO,
  SanctuaryReviewStatus,
  SanctuaryCounterDTO,
  SanctuaryRequestType
} from "../../types/sanctuary/sanctuaryTypes";

// --------------------------------------------------
// Sanctuary API
// --------------------------------------------------

export const sanctuaryApi = {
  // --------------------------------------------------
  // Requests
  // --------------------------------------------------

  listMyRequests: async () => {
    const { data } = await baseApi.get<SanctuaryRequestDTO[]>(
      "/sanctuary/sanctuary-requests/"
    );
    return data;
  },

  createRequest: async (payload: {
    request_type: SanctuaryRequestDTO["request_type"];
    reasons: string[];
    description?: string | null;
    content_type: string;
    object_id: number;
  }) => {
    const { data } = await baseApi.post<SanctuaryRequestDTO>(
      "/sanctuary/sanctuary-requests/",
      payload
    );
    return data;
  },

  // --------------------------------------------------
  // Council Reviews
  // --------------------------------------------------

  listMyReviews: async () => {
    const { data } = await baseApi.get<SanctuaryReviewDTO[]>(
      "/sanctuary/council-reviews/"
    );
    return data;
  },

  submitReview: async (
    reviewId: number,
    payload: {
      review_status: SanctuaryReviewStatus;
      comment?: string;
    }
  ) => {
    const { data } = await baseApi.patch<SanctuaryReviewDTO>(
      `/sanctuary/council-reviews/${reviewId}/`,
      payload
    );
    return data;
  },

  // --------------------------------------------------
  // Outcomes
  // --------------------------------------------------

  listMyOutcomes: async () => {
    const { data } = await baseApi.get<SanctuaryOutcomeDTO[]>(
      "/sanctuary/sanctuary-outcomes/"
    );
    return data;
  },

  appealOutcome: async (
    outcomeId: number,
    appeal_message?: string
  ) => {
    const { data } = await baseApi.post(
      `/sanctuary/sanctuary-outcomes/${outcomeId}/appeal/`,
      { appeal_message }
    );
    return data;
  },

  // --------------------------------------------------
  // Participation
  // --------------------------------------------------

  getParticipationStatus: async (lang?: string) => {
    const { data } = await baseApi.get<SanctuaryParticipationStatusDTO>(
      "/sanctuary/sanctuary-participation/",
      { params: { lang } }
    );
    return data;
  },

  // sanctuaryApi.ts
  optIn: async (policyId: number, lang?: string) => {
    const { data } = await baseApi.post<SanctuaryParticipationStatusDTO>(
      "/sanctuary/sanctuary-participation/opt-in/",
      { policy_id: policyId },
      { params: { lang } }
    );
    return data;
  },


  optOut: async () => {
    const { data } = await baseApi.post<SanctuaryParticipationStatusDTO>(
      "/sanctuary/sanctuary-participation/opt-out/"
    );
    return data;
  },

  // --------------------------------------------------
  // Counter
  // --------------------------------------------------

  getCounter: async (params: {
    request_type: SanctuaryRequestDTO["request_type"];
    content_type: string;
    object_id: number;
  }) => {
    const { data } = await baseApi.get<SanctuaryCounterDTO>(
      "/sanctuary/sanctuary-requests/counter/",
      { params }
    );
    return data;
  },

  // --------------------------------------------------
  // Reasons
  // --------------------------------------------------
  getReasons: async (params: {
    request_type: SanctuaryRequestType;
  }) => {
    const { data } = await baseApi.get<{
      request_type: SanctuaryRequestType;
      reasons: { code: string; label: string }[];
    }>("/sanctuary/sanctuary-requests/reasons/", { params });

    return data;
  },


};
